import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import Skeleton from '@material-ui/lab/Skeleton';

import CloseIcon from '../../CustomIcons/CloseIcon';
import { SlideUpTransition } from '../../Transitions/Transitions';
import promoImage from '../../../Assets/images/copaTrivia60_500x500.png';

const CampaignPromoDialog = ({ open, onClose, onConfirm }) => {
  const classes = useStyles();
  const isMobileSize = useMediaQuery(theme => theme.breakpoints.down('sm'));
  const [imageLoaded, setImageLoaded] = useState(false);

  let imageStyle = {};
  if (!imageLoaded) {
    imageStyle = { display: 'none' };
  }

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      classes={{ paper: classes.paper }}
      TransitionComponent={isMobileSize ? SlideUpTransition : undefined}
    >
      <DialogTitle disableTypography className={classes.title}>
        <Typography className={classes.titleText}>Trivia Copa 60</Typography>
        <IconButton
          size="small"
          aria-label="cerrar diálogo"
          onClick={onClose}
          className={classes.titleButton}
        >
          <CloseIcon size={15} className={classes.titleIcon} />
        </IconButton>
      </DialogTitle>
      <DialogContent className={classes.content}>
        <div className={classes.imageContainer}>
          {!imageLoaded && (
            <div className={classes.skeletonWrapper}>
              <Skeleton variant="rect" width="100%" height="100%" />
            </div>
          )}
          <img
            src={promoImage}
            alt="Trivia Copa 60"
            className={classes.image}
            style={imageStyle}
            onLoad={() => setImageLoaded(true)}
            onClick={onConfirm}
          />
        </div>
      </DialogContent>
    </Dialog>
  );
};

const useStyles = makeStyles(theme => ({
  paper: {
    borderRadius: theme.custom.borderRadius,
    overflowX: 'hidden'
  },
  title: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    height: 70,
    paddingLeft: theme.spacing(4),
    paddingRight: theme.spacing(2),
    background: 'linear-gradient(280deg, #0C3B52, #1D7FA8)'
  },
  titleText: {
    color: 'white',
    fontSize: 16,
    fontWeight: 600
  },
  titleButton: {
    padding: theme.spacing(1.5)
  },
  titleIcon: {
    fill: 'white'
  },
  content: {
    padding: 0,
    '&:last-child': {
      paddingBottom: 0
    }
  },
  imageContainer: {
    position: 'relative',
    paddingBottom: '100%'
  },
  skeletonWrapper: {
    position: 'absolute',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  },
  image: {
    position: 'absolute',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    width: '100%',
    display: 'block',
    cursor: 'pointer'
  }
}));

export default CampaignPromoDialog;
